module.exports = __webpack_public_path__ + "static/img/partner-logo5.d0959d02.jpg";